<template>
  <div class="space-y-6">
    <ReportTitle :title="$gettext('Rapport de personne physique')" :date="report?.attributes?.createdAt" />
    <div v-if="person" class="nobreak">
      <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $gettext("Identité") }}</h3>
      <div class="max-w-md">
        <dl class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
          <dt class="font-medium text-gray-700">{{ $gettext("Nom et prénom") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ person?.attributes?.firstName }} {{ person?.attributes?.lastName }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Date de naissance") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ parseDate(person?.attributes?.birthdate) }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Lieu de naissance") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ person?.attributes?.birthCity }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Nationalité") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ person?.attributes?.nationality }}
          </dd>
        </dl>
      </div>
    </div>

    <div v-if="person" class="nobreak">
      <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $gettext("Adresse") }}</h3>
      <p class="text-sm font-bold">
        {{ person?.attributes?.addressStreet }},
        {{ person?.attributes?.addressZipcode }} {{ person?.attributes?.addressCity }}
      </p>
    </div>
    <ReportRiskScoringBlock :riskScoring="riskScoring" :showSanctionsBlock="true" />
    <ReportDocumentsBlock :documents="person?.relationships?.physicalPersonDocuments?.data" />
  </div>
</template>

<script setup>
import ReportTitle from "@/components/reports/ReportTitle.vue";
import ReportDocumentsBlock from "@/components/reports/ReportDocumentsBlock.vue";
import { useGettext } from "vue3-gettext";
import ReportRiskScoringBlock from "./ReportRiskScoringBlock.vue";
import { useDate } from "@/utils/stores/date";

const { parseDate } = useDate();
const { $gettext } = useGettext();

const props = defineProps({
  report: {
    type: Object,
    required: true
  }
});

const person = props.report?.attributes?.data;
const riskScoring =
  person?.relationships?.lastRiskScoring?.data
    ? person.relationships.lastRiskScoring.data
    : null;
</script>
